/* DOGGO buy box (CRO v3): one shared state for the buy box, the package sheet and the sticky bar. */
(() => {
  'use strict';
  if (customElements.get('product-buy')) return;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const ui = () => window.DoggoUI || {};
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const fill = (tpl, data) => String(tpl || '').replace(/\{(\w+)\}/g, (m, k) => (k in data ? data[k] : m));
  const pct = (part, whole) => (whole > 0 ? Math.round((1 - part / whole) * 100) : 0);

  class ProductBuy extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try {
        this.config = JSON.parse($('[data-bb-config]', this).textContent);
      } catch (e) {
        return;
      }
      const c = this.config;
      this.variants = c.variants || [];
      this.base = this.variants.find((v) => v.id === c.base) || this.variants[0];
      this.state = { plan: c.sub ? c.plan : 'once', variant: c.variant, tier: Number(c.tier) || 0 };
      this.form = $('[data-bb-form]', this);
      this.sheet = $('[data-bb-sheet]', this);
      this.sticky = $('[data-bb-sticky]', this);

      /* Overlays live on <body> so no zoom, transform or overflow on an ancestor can break position: fixed. */
      if (this.sheet) document.body.appendChild(this.sheet);
      if (this.sticky) document.body.appendChild(this.sticky);
      this.roots = [this, this.sheet, this.sticky].filter(Boolean);

      this.fillOptions();
      this.bind();
      this.initGallery();
      this.initQuotes();
      this.initSticky();
      this.render();
    }

    disconnectedCallback() {
      /* Section reload in the theme editor: remove the moved overlays too. */
      if (this.sheet && this.sheet.parentNode === document.body) this.sheet.remove();
      if (this.sticky && this.sticky.parentNode === document.body) this.sticky.remove();
      if (this._io) this._io.disconnect();
      clearInterval(this._quoteTimer);
    }

    money(cents) {
      return ui().formatMoney ? ui().formatMoney(Math.round(cents), this.config.moneyFormat) : (cents / 100).toFixed(2);
    }

    variant() {
      return this.variants.find((v) => v.id === Number(this.state.variant)) || this.variants[0];
    }

    tier() {
      const tiers = this.config.tiers || [];
      return tiers[this.state.tier] || { name: '', chews: this.state.tier + 1 };
    }

    /* Labels, badges, savings and prices for every package option, from the variant data only. */
    fillOptions() {
      const base = this.base;
      this.variants.forEach((v) => {
        const anchor = v.compare > v.price ? v.compare : (base && v.cans > 1 ? base.price * v.cans : 0);
        const save = anchor > v.price ? pct(v.price, anchor) : 0;
        const perCan = v.cans > 1 ? `${this.money(v.price / v.cans)} ${this.config.text.perCanShort || this.config.text.perCan}` : '';
        $$(`[data-variant-pick="${v.id}"]`, document).forEach((btn) => {
          const set = (slot, text) => {
            const el = $(`[data-slot="${slot}"]`, btn);
            if (!el) return;
            el.textContent = text || '';
            el.hidden = !text;
          };
          set('label', v.label || v.title);
          set('badge', v.badge);
          set('save', save > 0 ? `−${save} %` : '');
          set('sub', v.sub || perCan);
          set('per', perCan);
          set('price', this.money(v.price));
          set('compare', anchor > v.price ? this.money(anchor) : '');
        });
      });
    }

    bind() {
      const onClick = (e) => {
        const plan = e.target.closest('[data-plan-pick]');
        if (plan) { this.set({ plan: plan.dataset.planPick }); return; }
        const pick = e.target.closest('[data-variant-pick]');
        if (pick && !pick.disabled) { this.set({ variant: Number(pick.dataset.variantPick), plan: 'once' }); return; }
        const dog = e.target.closest('[data-tier]');
        if (dog) { this._pos = null; this.set({ tier: Number(dog.dataset.tier) }); return; }
        if (e.target.closest('[data-sheet-close]')) { this.closeSheet(); return; }
        if (e.target.closest('[data-bb-sheet-open]')) { this.openSheet(e.target.closest('button')); return; }
        if (e.target.closest('[data-bb-sheet-submit]')) { this.submit(e.target.closest('button')); }
      };
      this.roots.forEach((r) => r.addEventListener('click', onClick));
      this.roots.forEach((r) => r.addEventListener('input', (e) => {
        if (!e.target.matches('[data-bb-tier]')) return;
        /* The slider moves freely (0–100); the nearest weight tier is selected while dragging. */
        const pos = Number(e.target.value);
        const steps = Math.max(1, (this.config.tiers || []).length - 1);
        this._pos = pos;
        this.set({ tier: Math.round((pos / 100) * steps) });
      }));
      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.submit($('[data-bb-submit]', this.form));
        });
      }
      if (this.sheet) this.bindSheet();
      document.addEventListener('doggo:cart-updated', () => this.syncSticky());
    }

    set(patch) {
      const prev = { ...this.state };
      Object.assign(this.state, patch);
      if (this.state.plan === 'sub' && !this.config.sub) this.state.plan = 'once';
      this.render(prev);
    }

    render(prev = {}) {
      const s = this.state;
      const c = this.config;
      const v = this.variant();
      const tier = this.tier();
      const isSub = s.plan === 'sub' && c.sub;
      const cans = Math.max(1, tier.chews || s.tier + 1);
      const subTotal = c.sub ? c.sub.price * cans : 0;
      const subAnchor = c.sub ? c.sub.compare * cans : 0;
      const days = c.planDays || 90;

      const setText = (key, text) => this.roots.forEach((r) => $$(`[data-bb="${key}"]`, r).forEach((el) => { el.textContent = text; }));

      /* Plans */
      this.roots.forEach((r) => {
        $$('[data-plan-card]', r).forEach((card) => card.classList.toggle('is-active', card.dataset.planCard === s.plan));
        $$('[data-plan-pick]', r).forEach((b) => {
          const on = b.dataset.planPick === s.plan;
          if (b.getAttribute('role') === 'tab') b.setAttribute('aria-selected', String(on));
          else if (b.getAttribute('role') === 'radio') b.setAttribute('aria-checked', String(on));
        });
        $$('[data-variant-pick]', r).forEach((b) => {
          const on = Number(b.dataset.variantPick) === v.id && s.plan === 'once';
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', String(on));
        });
      });
      const once = $('[data-bb-once]', this);
      const sub = $('[data-bb-sub]', this);
      if (once) once.hidden = s.plan !== 'once';
      if (sub) sub.hidden = s.plan !== 'sub';
      if (this.sheet) {
        const so = $('[data-sheet-once]', this.sheet);
        const ss = $('[data-sheet-sub]', this.sheet);
        if (so) so.hidden = s.plan !== 'once';
        if (ss) ss.hidden = s.plan !== 'sub';
      }

      /* Weight tier */
      setText('tier-name', tier.name);
      this.roots.forEach((r) => {
        $$('[data-bb-tier]', r).forEach((input) => {
          const steps = Math.max(1, (c.tiers || []).length - 1);
          const posTier = Math.round((Number(input.value) / 100) * steps);
          if (this._pos != null && posTier === s.tier) { if (input !== document.activeElement) input.value = this._pos; }
          else if (posTier !== s.tier) { input.value = Math.round((s.tier / steps) * 100); this._pos = null; }
          input.setAttribute('aria-valuetext', tier.name);
        });
        $$('[data-tier]', r).forEach((d) => d.classList.toggle('is-active', Number(d.dataset.tier) === s.tier));
      });
      const giant = $('[data-bb-giant]', this);
      if (giant) giant.hidden = s.tier < (c.tiers || []).length - 1;

      /* Subscription numbers */
      if (c.sub) {
        setText('sub-total', this.money(subTotal));
        setText('sub-anchor', this.money(subAnchor));
        setText('sub-per', `${this.money(c.sub.price)} ${c.text.perCan}`);
        setText('sub-day', this.money(subTotal / days));
        setText('sub-boxes', fill(cans === 1 && c.text.boxesOne ? c.text.boxesOne : c.text.boxes, { count: cans }));
        setText('sub-save', fill(c.text.saveLine, { amount: this.money(subAnchor - subTotal) }));
        const off = pct(c.sub.price, c.sub.compare);
        if (off > 0) setText('sub-tag', `−${off} %`);
        this.renderJars(cans);
      }

      /* Summary + button */
      const price = isSub ? subTotal : v.price;
      setText('summary', isSub
        ? fill(c.text.summarySub, { total: this.money(subTotal), days, per_day: this.money(subTotal / days) })
        : fill(c.text.summaryOnce, { price: this.money(v.price) }));
      const available = isSub ? this.base.available : v.available;
      setText('cta', available ? fill(isSub ? c.text.ctaSub : c.text.ctaOnce, { price: this.money(price) }) : c.text.soldOut);
      this.roots.forEach((r) => $$('[data-bb-submit], [data-bb-sheet-submit]', r).forEach((b) => { b.disabled = !available; }));
      $$('[data-bb-sheet-submit]', document).forEach((b) => { b.classList.toggle('btn--gold', isSub); b.classList.toggle('btn--green', !isSub); });

      /* Form fields (what is really added to the cart) */
      if (this.form) {
        const id = $('[data-bb-input="id"]', this.form);
        const qty = $('[data-bb-input="quantity"]', this.form);
        const plan = $('[data-bb-input="plan"]', this.form);
        id.value = isSub ? this.base.id : v.id;
        qty.value = isSub ? cans : 1;
        plan.value = isSub ? c.sub.plan : '';
        plan.disabled = !isSub;
      }

      /* Variant change: image + URL */
      if (prev.variant !== undefined && prev.variant !== s.variant) {
        if (v.media) this.goToMedia(v.media);
        if (this.dataset.updateUrl === 'true' && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        this.dispatchEvent(new CustomEvent('doggo:variant-change', { bubbles: true, detail: { variant: v } }));
      }
    }

    renderJars(cans) {
      this.roots.forEach((r) => $$('[data-bb-jars]', r).forEach((box) => {
        const imgs = $$('img', box);
        if (!imgs.length || imgs.length === cans) return;
        while ($$('img', box).length < cans) box.appendChild(imgs[0].cloneNode(true));
        while ($$('img', box).length > cans) box.lastElementChild.remove();
      }));
    }

    async submit(button) {
      if (!this.form || !button || button.disabled) return;
      const err = $('[data-bb-error]', this);
      const data = new FormData(this.form);
      const item = { id: Number(data.get('id')), quantity: Number(data.get('quantity')) || 1 };
      if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
      const buttons = this.roots.flatMap((r) => $$('[data-bb-submit], [data-bb-sheet-submit]', r));
      buttons.forEach((b) => { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
      if (err) err.hidden = true;
      try {
        if (!window.DoggoCart) throw new Error(this.config.text.addError);
        if (this.sheet && !this.sheet.hidden) this.closeSheet(true);
        await window.DoggoCart.add([item]);
      } catch (e) {
        if (err) { err.textContent = e.message || this.config.text.addError; err.hidden = false; }
        if (this.sheet && !this.sheet.hidden) this.closeSheet();
      } finally {
        buttons.forEach((b) => { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
      }
    }

    /* ------------------------------------------------------------------ */
    /* Gallery: native scroll-snap slider, arrows, thumbs, dots           */
    /* ------------------------------------------------------------------ */
    initGallery() {
      this.track = $('[data-bb-track]', this);
      if (!this.track) return;
      this.slides = $$('.bb__slide', this.track);
      this.thumbs = $$('[data-bb-thumbs] .bb__thumb', this);
      this.dots = $$('.bb__dot', this);
      let raf;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.markSlide(Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))));
      }, { passive: true });
      $('[data-bb-prev]', this)?.addEventListener('click', () => this.goTo(this.index - 1));
      $('[data-bb-next]', this)?.addEventListener('click', () => this.goTo(this.index + 1));
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.goTo(Number(t.dataset.index))));
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); }
      });
      this.index = 0;
      this.fitStickyMedia();
    }

    goTo(i) {
      if (!this.slides || !this.slides.length) return;
      const n = this.slides.length;
      const idx = ((i % n) + n) % n;
      this.track.scrollTo({ left: idx * this.track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      this.markSlide(idx);
    }

    goToMedia(mediaId) {
      const idx = (this.slides || []).findIndex((s) => Number(s.dataset.mediaId) === Number(mediaId));
      if (idx >= 0) this.goTo(idx);
    }

    markSlide(idx) {
      if (idx === this.index && this._marked) return;
      this._marked = true;
      this.index = idx;
      this.thumbs.forEach((t, i) => {
        const on = i === idx;
        t.classList.toggle('is-active', on);
        if (on) {
          t.setAttribute('aria-current', 'true');
          const strip = t.parentElement;
          const left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
          strip.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
        } else t.removeAttribute('aria-current');
      });
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }

    /* Keep the sticky gallery below the sticky header; it only sticks while the info column is longer. */
    fitStickyMedia() {
      const media = $('[data-bb-media]', this);
      if (!media) return;
      const fit = () => {
        /* Measure in screen pixels, then divide by the body zoom to get the CSS value. */
        const zoom = parseFloat(getComputedStyle(document.body).zoom) || 1;
        const wrap = document.querySelector('[data-header-wrap]');
        let head = 0;
        if (wrap && getComputedStyle(wrap).position === 'sticky') {
          const bar = wrap.querySelector('.section-annbar');
          head = wrap.getBoundingClientRect().height - (bar ? bar.getBoundingClientRect().height : 0);
        }
        const gap = 16 * zoom;
        const top = Math.min(head + gap, window.innerHeight - media.getBoundingClientRect().height - gap);
        this.style.setProperty('--bb-sticky-top', `${Math.max(gap, top) / zoom}px`);
      };
      fit();
      window.addEventListener('resize', fit, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(fit).observe(media);
    }

    /* ------------------------------------------------------------------ */
    /* Rotating customer quote below the gallery                          */
    /* ------------------------------------------------------------------ */
    initQuotes() {
      const box = $('[data-bb-quotes]', this);
      if (!box) return;
      const quotes = $$('.bb__quote', box);
      if (quotes.length < 2 || reduceMotion) return;
      let i = 0;
      this._quoteTimer = setInterval(() => {
        if (document.hidden) return;
        quotes[i].classList.remove('is-active');
        i = (i + 1) % quotes.length;
        quotes[i].classList.add('is-active');
      }, Number(box.dataset.interval) || 8500);
    }

    /* ------------------------------------------------------------------ */
    /* Package sheet                                                      */
    /* ------------------------------------------------------------------ */
    bindSheet() {
      const panel = $('.pkg__panel', this.sheet);
      this.sheet.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); this.closeSheet(); }
        if (e.key === 'Tab' && ui().trapFocus) ui().trapFocus(panel, e);
      });
      /* Swipe down on the handle or the header to close (mobile). */
      let y0 = null; let dy = 0;
      const start = (e) => { if (window.innerWidth > 760) return; y0 = e.touches[0].clientY; dy = 0; panel.style.transition = 'none'; };
      const move = (e) => {
        if (y0 === null) return;
        dy = Math.max(0, e.touches[0].clientY - y0);
        panel.style.transform = `translateY(${dy}px)`;
      };
      const end = () => {
        if (y0 === null) return;
        panel.style.transition = '';
        if (dy > 90) this.closeSheet();
        else panel.style.transform = '';
        y0 = null;
      };
      [$('.pkg__handle', this.sheet), $('.pkg__title', this.sheet)].filter(Boolean).forEach((el) => {
        el.addEventListener('touchstart', start, { passive: true });
        el.addEventListener('touchmove', move, { passive: true });
        el.addEventListener('touchend', end);
        el.addEventListener('touchcancel', end);
      });
    }

    openSheet(trigger) {
      if (!this.sheet || !this.sheet.hidden) return;
      this._sheetTrigger = trigger || document.activeElement;
      this.sheet.hidden = false;
      this.sheet.classList.remove('is-closing');
      const panel = $('.pkg__panel', this.sheet);
      panel.style.transform = '';
      document.body.classList.add('has-sheet-open');
      if (ui().scrollLock) ui().scrollLock.lock();
      requestAnimationFrame(() => panel.focus({ preventScroll: true }));
      this.syncSticky();
    }

    closeSheet(keepFocus) {
      if (!this.sheet || this.sheet.hidden || this.sheet.classList.contains('is-closing')) return;
      const done = () => {
        this.sheet.hidden = true;
        this.sheet.classList.remove('is-closing');
        $('.pkg__panel', this.sheet).style.transform = '';
      };
      document.body.classList.remove('has-sheet-open');
      if (ui().scrollLock) ui().scrollLock.unlock();
      if (reduceMotion) done();
      else {
        this.sheet.classList.add('is-closing');
        setTimeout(done, 260);
      }
      if (!keepFocus && this._sheetTrigger && document.body.contains(this._sheetTrigger)) this._sheetTrigger.focus({ preventScroll: true });
      this.syncSticky();
    }

    /* ------------------------------------------------------------------ */
    /* Sticky bar: shows once the main button is off screen               */
    /* ------------------------------------------------------------------ */
    initSticky() {
      if (!this.sticky) return;
      this.cta = $('[data-bb-submit]', this);
      this.footer = document.querySelector('.section-footer, footer');
      this.vis = { cta: true, footer: false, section: false, hero: true, offers: true };
      if (!('IntersectionObserver' in window) || !this.cta) return;
      /* Hidden on the hero (first section, or the product gallery when the buy box is the first section)
         and while the offers, the main button or the footer are on screen. */
      const first = document.querySelector('#MainContent > .shopify-section, main > .shopify-section');
      this._hero = first && first.contains(this) ? $('.bb__media', this) : first;
      this._offers = $('.bb__plans', this);
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.target === this.cta) { this.vis.cta = en.isIntersecting; this.vis.passed = !en.isIntersecting && en.boundingClientRect.top < 0; }
          else if (en.target === this.footer) this.vis.footer = en.isIntersecting;
          else if (en.target === this._anchor) this.vis.section = en.isIntersecting || en.boundingClientRect.top < 0;
          if (en.target === this._hero) this.vis.hero = en.isIntersecting;
          if (en.target === this._offers) this.vis.offers = en.isIntersecting;
        });
        this.syncSticky();
      }, { threshold: 0, rootMargin: '-80px 0px -60px 0px' });
      this._io.observe(this.cta);
      if (this.footer) this._io.observe(this.footer);
      if (this._hero && this._hero !== this.cta) this._io.observe(this._hero); else this.vis.hero = false;
      if (this._offers) this._io.observe(this._offers); else this.vis.offers = false;
      /* Home page: only after the visitor reached the section above the buy box. */
      if (this.dataset.stickyMode === 'section') {
        this._anchor = document.querySelector('[data-sticky-anchor]') || this.previousElementSibling || this.parentElement.previousElementSibling;
        if (this._anchor) this._io.observe(this._anchor);
      } else this.vis.section = true;
    }

    syncSticky() {
      if (!this.sticky || !this.vis) return;
      const drawerOpen = document.body.classList.contains('has-drawer-open');
      const sheetOpen = this.sheet && !this.sheet.hidden;
      const passedOk = this.dataset.stickyMode !== 'after' || this.vis.passed;
      const show = !this.vis.cta && !this.vis.hero && !this.vis.offers && passedOk && !this.vis.footer && this.vis.section && !drawerOpen && !sheetOpen;
      if (show === this._stickyShown) return;
      this._stickyShown = show;
      this.sticky.classList.toggle('is-visible', show);
      this.sticky.setAttribute('aria-hidden', String(!show));
      $$('button', this.sticky).forEach((b) => { b.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('has-sticky-buy', show);
    }
  }

  customElements.define('product-buy', ProductBuy);

  /* Re-evaluate every sticky bar when a drawer opens or closes. */
  new MutationObserver(() => $$('product-buy').forEach((el) => el.syncSticky && el.syncSticky()))
    .observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
